import PageWrapper from '../components/PageWrapper';

import { Redirect } from 'react-router-dom';

const Page: React.FC = () => {
  return (
    <PageWrapper pageTitle="Plan A Play">    
      <Redirect to="/children" />
    </PageWrapper>
  )
}

export default Page;